/**
 * Labstep
 *
 * @module components/Sharelink/Action/Delete
 * @desc Action to delete
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { IShareLinkActionDeleteProps } from './types';

export const ShareLinkActionDelete: React.FC<
  IShareLinkActionDeleteProps
> = ({ shareLink, ...rest }) =>
  shareLink.organization ? (
    <EntityActionDelete {...rest} entity={shareLink} />
  ) : null;
